import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContainerService, BaseModalUpdateComponent, ModalService } from 'yt-ng-framework';
import { KursDokumentStavka } from './kurs-dokument-stavka';

@Component({
  selector: 'yt-kurs-dokument-stavka-modal-update',
  templateUrl: './kurs-dokument-stavka-modal-update.component.html'
})
export class KursDokumentStavkaModalUpdateComponent extends BaseModalUpdateComponent<KursDokumentStavka> {

  constructor(
    protected modalContainerService: ModalContainerService<KursDokumentStavka>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
){
    super(modalContainerService, activeModal,modalService);
}

  

}
